import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

export const LPG_VERTICAL_ID = 15;

export const ALL_FAQS_PAGE_SIZE = -1;

export const fetchFaqs = async ({
  verticalId = LPG_VERTICAL_ID,
  page = 1,
  pageSize = ALL_FAQS_PAGE_SIZE,
} = {}) => {
  const { data } = await CLIENT.get(ENDPOINTS.FAQS.root, {
    params: {
      ...(verticalId != null ? { verticalId } : {}),
      page,
      page_size: pageSize,
    },
  });

  return data;
};

export const fetchFaq = async (id) => {
  const { data } = await CLIENT.get(ENDPOINTS.FAQS.byId(id));

  return data;
};
